module.exports = __webpack_public_path__ + "img/balance.bd0e1639.png";